import axios from "axios";
import querystring from "querystring";
import moment from "moment";
import firebase from "firebase";

export default {
  getStripeProducts() {
    return new Promise((resolve, reject) => {
      axios
        .get(
          "https://api.stripe.com/v1/prices?active=true&expand[]=data.product",
          {
            headers: {
              Authorization: `Bearer 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`
            }
          }
        )
        .then(res => {
          console.log("res", res);
          resolve(((res || {}).data || {} || {}).data || []);
        })
        .catch(err => {
          console.log("err occured", err);
          reject(err);
        });
    });
  },
  createToken(params) {
    return new Promise((resolve, reject) => {
      let body = querystring.stringify({
        "card[number]": params.number,
        "card[exp_month]": params.exp_month,
        "card[exp_year]": params.exp_year,
        "card[cvc]": params.cvc
      });

      axios
        .post("https://api.stripe.com/v1/tokens", body, {
          headers: {
            Authorization: `Bearer pk_live_519bxa1H9q88vhZpE8WewngaRckO7gwO0A1UtT0Az7kg6G5Kaeguwjv1LoOjriWIjskG2JpeR5YXcqEiXGuJHr8z400gNNn29jc`,
            ContentType: "application/x-www-form-urlencoded"
          }
        })
        .then(res => {
          console.log("token response", res);
          resolve(res);
        })
        .catch(err => {
          console.log("err occured", err);
          reject(err);
        });
    });
  },
  getTotalUsersStats() {
    return firebase.database().ref("stats/usersCount");
  },
  getActiveSubscriberStats() {
    return firebase.database().ref("stats/activeSubscribersCount");
  },
  sendSignals(data) {
    return axios.post(
      "https://us-central1-spyows.cloudfunctions.net/sendSignals",
      JSON.stringify(data),
      {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*"
        }
      }
    );
  }
};
